export default "__VITE_ASSET__Cj3DwSMY__"